/**
 * PlaygroundPageLayout.tsx
 * Shared layout component for all playground pages
 * 
 * Provides consistent structure with automatic breadcrumb navigation,
 * replacing the need for individual PlaygroundHeader components.
 */

import React from 'react';
import { PlaygroundBreadcrumbs } from './PlaygroundBreadcrumbs';

interface PlaygroundPageLayoutProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * PlaygroundPageLayout Component
 * 
 * Wraps playground pages with consistent layout structure.
 * Automatically includes breadcrumb navigation and proper spacing.
 * 
 * @example
 * <PlaygroundPageLayout>
 *   <div className="space-y-8">
 *     <ComponentExamples />
 *   </div>
 * </PlaygroundPageLayout>
 */
export const PlaygroundPageLayout: React.FC<PlaygroundPageLayoutProps> = ({ 
  children, 
  className = '' 
}) => {
  return (
    <div className="min-h-screen bg-background">
      {/* Automatic Breadcrumb Navigation */}
      <PlaygroundBreadcrumbs />
      
      {/* Page Content */}
      <div className={`p-6 ${className}`}>
        {children}
      </div>
    </div>
  );
};

export default PlaygroundPageLayout;